import { render, staticRenderFns } from "./topLiveCard.vue?vue&type=template&id=c0fbe916&scoped=true&"
import script from "./topLiveCard.vue?vue&type=script&lang=js&"
export * from "./topLiveCard.vue?vue&type=script&lang=js&"
import style0 from "./topLiveCard.vue?vue&type=style&index=0&id=c0fbe916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0fbe916",
  null
  
)

export default component.exports